/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import { setUpErrorHandling } from '@bingads-webui-campaign/summary-grid-helper';

import { CampaignsGrid } from './campaigns-grid';
import { getConfig } from './grid-config';
import { getCampaignsPlugins } from './plugins';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');

export function createCampaignsGrid({
  dataSource,
  filterService,
  getAdditionalPlugins = () => [],
  preferenceConfig,
  preferenceService,
  router,
  scope,
  addDateChangeListener,
  p$daterange,
  isForVNext = false,
  viewport,
  gridConfig,
  instrumentation,
  serverContext,
  campaignTabPerfMarker,
  customHeaderOffset,
  isDataFetchManagerSource,
  gridName,
  pageName,
  preexecuteFlag = false,
  theme,
  processReportRule,
  gridId,
  enableCopyPaste = true,
  azureUrlRewrite,
  getCampaignTypeGlobalFilter,
  newI18n,
}) {
  // performance targets details page also use campaign grid
  // verify functionalility to avoid regression after modification
  return new CampaignsGrid({
    isForVNext,
    enableCopyPaste,
    filterService,
    gridConfig,
    serverContext,
    instrumentation,
    newI18n,
    getGridConfig: view => getConfig({
      dataSource,
      scope,
      view,
      filterService,
      preferenceConfig,
      router,
      isForVNext,
      viewport,
      customHeaderOffset,
      isDataFetchManagerSource,
      gridName,
      instrumentation,
      getCampaignTypeGlobalFilter,
    }),
    getPlugins: view => getCampaignsPlugins({
      filterService,
      router,
      scope,
      isForVNext,
      addDateChangeListener,
      p$daterange,
      campaignTabPerfMarker,
      viewport,
      processReportRule,
      gridId,
      preexecuteFlag,
      getCampaignTypeGlobalFilter,
      preferenceService,
    }).concat(getAdditionalPlugins(view)),
    router,
    scope,
    setupDataSourceErrorHandling: view => setUpErrorHandling({
      gridView: view,
      scope,
      dataSource,
      i18n,
    }),
    preferenceConfig,
    pageName,
    preexecuteFlag,
    theme,
    azureUrlRewrite,
    perfMarker: campaignTabPerfMarker,
  });
}
